/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum DirectionOrder {
  ASC="ASC",
DESC="DESC"
}

/**
* DirectionOrder
*/
export const DirectionOrderEnumType = types.enumeration("DirectionOrder", [
        "ASC",
  "DESC",
      ])
